import axios from 'axios'

// const api_endpoint = 'http://127.0.0.1:5001'
const api_endpoint = 'https://csp.api.docmasweetspot.ca'

function get_all_users(token){
    let api_url = api_endpoint+'/user_management/get_all_users';
    let data = {};
    return axios_post_call(api_url,data,token);
}

function get_user_orgs(token, user_id){
    let api_url = api_endpoint+'/user_management/get_user_orgs';
    let data = {"user_id": user_id};
    return axios_post_call(api_url,data,token);
}

function create_new_user(token, user_payload) {
    let api_url = api_endpoint+'/user_management/create_new_user'
    return(axios_post_call(api_url, user_payload, token))
}

function get_org_users(token, org_id){
    let api_url = api_endpoint+'/user_management/get_org_users';
    let data = {"org_id": org_id};
    return axios_post_call(api_url,data,token);
}
function add_org_members(token, org_id, user_ids){
    let api_url = api_endpoint+'/user_management/add_org_members';
    let data = {"org_id": org_id, "user_ids": user_ids};
    return axios_post_call(api_url,data,token);
}

function remove_org_member(token, org_id, user_id){
    let api_url = api_endpoint+'/user_management/remove_org_member';
    let data = {"org_id": org_id, "user_id": user_id};
    return axios_post_call(api_url,data,token);
}

function edit_user(token, user_payload) {
    let api_url = api_endpoint+'/user_management/edit_user';
    return axios_post_call(api_url, user_payload, token);
}

function invite_org_member(token, org_id, inviter, invitee_email){
    let api_url = api_endpoint+'/user_management/invite_org_member';
    let data = {"org_id": org_id, "inviter": inviter, "invitee_email": invitee_email};
    return axios_post_call(api_url,data,token);
}

function update_org_member_permissions(token, user_id, access){
    let api_url = api_endpoint+'/user_management/update_org_members_permissions';
    let data = {'user_id': user_id, 'access': access};
    return axios_post_call(api_url,data,token);
}

function get_my_permissions(token, user_id){
    let api_url = api_endpoint+'/user_management/get_my_permissions';
    let data = {'user_id': user_id};
    return axios_post_call(api_url,data,token);
}


/*
Base Caller functions
*/
function axios_post_call(api_url,data,token){
    return new Promise(function(resolve,reject){
        axios.post(api_url, data, {headers: {Authorization: `Bearer ${token}`}}).then((res)=>{
            if(res.status == 200){
                resolve(res.data);
            }
            else{
                reject();
            }
        }).catch((e)=>{
            reject(api_url+e);
        })
    })
}

export default {
    get_all_users,
    get_user_orgs,
    get_org_users,
    create_new_user,
    add_org_members,
    remove_org_member,
    edit_user,
    invite_org_member,
    update_org_member_permissions,
    get_my_permissions
}
